/* Mobile-only infinite scroll for collection product grids.
   Reuses Shopify section rendering (?section_id=) of the existing product-grid
   section, so cards are the exact same markup as page 1. Desktop pagination
   is untouched. If JS fails, the numbered pagination stays visible. */
(function () {
  if (window.__vemicaInfiniteScroll) return;
  window.__vemicaInfiniteScroll = true;

  var MOBILE_QUERY = window.matchMedia('(max-width: 749px)');
  var ROOT_MARGIN = '0px 0px 900px 0px';
  var STYLE_ID = 'cis-style';

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var css =
      '@media screen and (max-width: 749px){' +
      '.cis-enabled .pagination-wrapper{display:none !important;}' +
      '.cis-status{display:flex;justify-content:center;align-items:center;min-height:4.8rem;margin:1.6rem 0 0.8rem;}' +
      '.cis-status[hidden]{display:none;}' +
      '.cis-spinner{width:2.8rem;height:2.8rem;border-radius:50%;border:0.3rem solid rgba(var(--color-foreground),0.15);border-top-color:rgb(var(--color-foreground));animation:cis-spin 0.8s linear infinite;}' +
      '.cis-retry{font:inherit;font-size:1.4rem;padding:1rem 2rem;border-radius:4rem;border:0.1rem solid rgba(var(--color-foreground),0.4);background:transparent;color:rgb(var(--color-foreground));cursor:pointer;min-height:4.4rem;}' +
      '}' +
      '@media (prefers-reduced-motion: reduce){.cis-spinner{animation-duration:2s;}}' +
      '@keyframes cis-spin{to{transform:rotate(360deg);}}';
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = css;
    document.head.appendChild(style);
  }

  function pageFromHref(href) {
    try {
      var p = new URL(href, window.location.origin).searchParams.get('page');
      return p ? parseInt(p, 10) : 1;
    } catch (e) {
      return NaN;
    }
  }

  // Next page URL taken from Shopify's own pagination markup.
  function getNextUrl(scope) {
    var wrapper = scope.querySelector('.pagination-wrapper');
    if (!wrapper) return null;
    var currentEl = wrapper.querySelector('[aria-current="page"], .pagination__item--current');
    var current = currentEl ? parseInt(currentEl.textContent, 10) : parseInt(wrapper.getAttribute('data-page'), 10);
    if (!current || isNaN(current)) current = 1;
    var links = wrapper.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      if (pageFromHref(links[i].getAttribute('href')) === current + 1) {
        return new URL(links[i].getAttribute('href'), window.location.origin).toString();
      }
    }
    return null;
  }

  function productKey(li) {
    var a = li.querySelector('a[href*="/products/"]');
    if (a) {
      try {
        var path = new URL(a.getAttribute('href'), window.location.origin).pathname;
        var m = path.match(/\/products\/([^/?#]+)/);
        if (m) return m[1];
      } catch (e) {}
    }
    return li.id || li.innerHTML.length + ':' + (li.textContent || '').trim().slice(0, 80);
  }

  function countLabel(n) {
    return n + (n === 1 ? ' more product loaded.' : ' more products loaded.');
  }

  function refreshApps(container) {
    // Judge.me star badges on newly added cards
    try {
      if (window.jdgm) {
        if (typeof window.jdgm.customizeBadges === 'function') window.jdgm.customizeBadges();
        if (typeof window.jdgm.initializeWidgets === 'function') window.jdgm.initializeWidgets();
      }
    } catch (e) {}
    try {
      document.dispatchEvent(new CustomEvent('collection:products-appended', { detail: { container: container } }));
    } catch (e) {}
  }

  function InfiniteGrid(gridContainer) {
    this.gridContainer = gridContainer;
    this.section = gridContainer.closest('.shopify-section');
    this.sectionId = this.section ? this.section.id.replace('shopify-section-', '') : null;
    this.grid = gridContainer.querySelector('#product-grid');
    this.nextUrl = getNextUrl(gridContainer);
    this.loading = false;
    this.done = !this.nextUrl;
    this.requested = {};
    this.keys = {};
    this.observer = null;
    this.status = null;
  }

  InfiniteGrid.prototype.init = function () {
    if (!this.grid || !this.sectionId) return false;
    var self = this;
    var items = this.grid.children;
    for (var i = 0; i < items.length; i++) this.keys[productKey(items[i])] = true;

    if (this.section) this.section.classList.add('cis-enabled');
    if (this.done) return true; // single page: pagination hidden, nothing to load

    this.status = document.createElement('div');
    this.status.className = 'cis-status';
    this.status.setAttribute('role', 'status');
    this.status.setAttribute('aria-live', 'polite');
    this.status.innerHTML = '<span class="visually-hidden cis-msg"></span>';
    this.grid.parentNode.insertBefore(this.status, this.grid.nextSibling);

    this.observer = new IntersectionObserver(
      function (entries) {
        if (entries[0] && entries[0].isIntersecting) self.load();
      },
      { rootMargin: ROOT_MARGIN }
    );
    this.observer.observe(this.status);
    return true;
  };

  InfiniteGrid.prototype.setStatus = function (state, message) {
    if (!this.status) return;
    var msg = this.status.querySelector('.cis-msg');
    var spinner = this.status.querySelector('.cis-spinner');
    var retry = this.status.querySelector('.cis-retry');
    if (spinner) spinner.remove();
    if (retry) retry.remove();
    if (state === 'loading') {
      var s = document.createElement('span');
      s.className = 'cis-spinner';
      s.setAttribute('aria-hidden', 'true');
      this.status.insertBefore(s, msg);
    } else if (state === 'error') {
      var self = this;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cis-retry';
      b.textContent = 'Load more products';
      b.addEventListener('click', function () { self.load(); });
      this.status.insertBefore(b, msg);
    }
    if (msg) msg.textContent = message || '';
  };

  InfiniteGrid.prototype.load = function () {
    if (this.loading || this.done || !this.nextUrl || !MOBILE_QUERY.matches) return;
    if (this.requested[this.nextUrl]) { this.finish(); return; }
    var self = this;
    var url = this.nextUrl;
    this.requested[url] = true;
    this.loading = true;
    this.setStatus('loading', 'Loading more products');

    var fetchUrl = new URL(url);
    fetchUrl.searchParams.set('section_id', this.sectionId);

    fetch(fetchUrl.toString(), { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        if (!self.grid.isConnected) return; // grid replaced (e.g. filters) meanwhile
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('#product-grid');
        var added = 0;
        if (newGrid) {
          var frag = document.createDocumentFragment();
          Array.prototype.slice.call(newGrid.children).forEach(function (li) {
            var key = productKey(li);
            if (self.keys[key]) return; // prevent duplicates
            self.keys[key] = true;
            frag.appendChild(document.importNode(li, true));
            added++;
          });
          self.grid.appendChild(frag);
        }
        var next = getNextUrl(doc);
        if (!next || next === url || self.requested[next] || pageFromHref(next) <= pageFromHref(url)) next = null;
        self.nextUrl = next;
        self.loading = false;

        if (added) refreshApps(self.grid);

        if (!self.nextUrl) {
          self.finish(added ? countLabel(added) + ' All products shown.' : 'All products shown.');
          return;
        }
        self.setStatus('idle', added ? countLabel(added) : '');
        // If the sentinel is still near the viewport (short pages), keep going.
        window.requestAnimationFrame(function () {
          if (!self.status) return;
          var rect = self.status.getBoundingClientRect();
          if (rect.top < window.innerHeight + 900) self.load();
        });
      })
      .catch(function () {
        self.loading = false;
        delete self.requested[url];
        self.setStatus('error', 'Could not load more products.');
      });
  };

  InfiniteGrid.prototype.finish = function (message) {
    this.done = true;
    this.loading = false;
    if (this.observer) this.observer.disconnect();
    this.setStatus('idle', message || 'All products shown.');
  };

  InfiniteGrid.prototype.destroy = function () {
    if (this.observer) this.observer.disconnect();
    if (this.status && this.status.parentNode) this.status.parentNode.removeChild(this.status);
    if (this.section) this.section.classList.remove('cis-enabled');
  };

  var instances = [];

  function setup() {
    instances.forEach(function (i) { i.destroy(); });
    instances = [];
    if (!MOBILE_QUERY.matches || !('IntersectionObserver' in window)) return;
    injectStyles();
    document.querySelectorAll('#ProductGridContainer').forEach(function (container) {
      var inst = new InfiniteGrid(container);
      if (inst.init()) instances.push(inst);
      // Re-init when Dawn facets/sorting re-render the grid container.
      if (!container.__cisWatched) {
        container.__cisWatched = true;
        new MutationObserver(function () {
          clearTimeout(container.__cisTimer);
          container.__cisTimer = setTimeout(setup, 50);
        }).observe(container, { childList: true });
      }
    });
  }

  function onMediaChange() { setup(); }
  if (MOBILE_QUERY.addEventListener) MOBILE_QUERY.addEventListener('change', onMediaChange);
  else if (MOBILE_QUERY.addListener) MOBILE_QUERY.addListener(onMediaChange);

  document.addEventListener('shopify:section:load', setup);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
})();
